import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { GraphData } from '@classes/graph/graph';
import { RecordsCoudPouce } from '@classes/records/record';
import { DataService } from '@services/data/data.service';
import { RecordsService } from '@services/records/records.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';

@Component({
  selector: 'app-chart-sorted-weight',
  templateUrl: './chart-sorted-weight.component.html',
  styleUrls: ['./chart-sorted-weight.component.scss']
})
export class ChartSortedWeightComponent extends SubscriptionBaseComponent implements OnInit {

  @Input() numberDayOfMonth: number;
  @Input() year: number;
  // typeTime: string;
  // @Input() set typeTime(value: string) { this.typeTime = value; }

  public barChartOptions = {
    responsive: true,
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 50
      }
    }
  };

  arrayMonth = ['janv', 'fév', 'mars', 'avril', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'];

  public barChartLabels = [];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];

  data: RecordsCoudPouce[] = [];
  dataLabel: GraphData = {
    label: 'Poids Trié (kg)',
    data: []
  };

  public barChartData = [
    {
      label: 'Chariots de marchandises',
      stack: 'divisé',
      backgroundColor: '#7fcff7',
      hoverBackgroundColor: '#12a7ef',
      data: []
    },
    {
      label: 'Déchetterie',
      stack: 'groupé',
      backgroundColor: '#ffc7a2',
      hoverBackgroundColor: '#ffaf53',
      data: []
    },
    {
      label: 'Clicotte',
      stack: 'groupé',
      backgroundColor: '#ff9ebd',
      hoverBackgroundColor: '#ff4a86',
      data: []
    },
  ];
  // public barChartData: GraphData[] = [this.dataLabel];
  typeTime: string;

  constructor(
    private recordsService: RecordsService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
    this.initValueGraph();

  }

  private initGraph(): void {
    // this.barChartData = [];
    this.barChartLabels = [];
    this.barChartData[0].data = [];
    this.barChartData[1].data = [];
    this.barChartData[2].data = [];

    switch (this.typeTime) {
      case 'year':
        this.barChartLabels = this.arrayMonth;
        for (let i = 0; i < this.arrayMonth.length; i++) {
          this.barChartData[0].data.push(0);
          this.barChartData[1].data.push(0);
          this.barChartData[2].data.push(0);
        }
        break;
      case 'month':
        for (let i = 1; i <= this.numberDayOfMonth; i++) {
          i < 10 ?
            this.barChartLabels.push('0' + i) :
            this.barChartLabels.push(i.toString());
          this.barChartData[0].data.push(0);
          this.barChartData[1].data.push(0);
          this.barChartData[2].data.push(0);
        }
        break;

      default:
        break;
    }

  }

  private initValueGraph(): void {
    const dataFilter = [];
    this.data?.forEach(item => {
      if (item.step.description === 'Tri') {
        dataFilter.push(item);
      }
    });

    switch (this.typeTime) {
      case 'month':
        this.barChartLabels.forEach((item, index) => {
          // let valuePerDay = 0;
          dataFilter?.forEach(data => {
            const day = data.createdOn.split('T')[0].split('-')[2];
            if (item === day) {
              if (data.type === 'Input') {
                this.barChartData[0].data[index] += data.value;
              } else if (data.type === 'Output' && data.category.name === 'Déchetterie') {
                this.barChartData[1].data[index] += data.value;

              } else if (data.type === 'Output' && data.category.name === 'Clicotte') {
                this.barChartData[2].data[index] += data.value;
              }
            }
          });
        });
        break;
      case 'year':
        this.barChartLabels.forEach((item, index) => {
          // let valuePerDay = 0;
          dataFilter?.forEach(data => {
            const month = new Date(data.createdOn).getMonth();
            const year = new Date(data.createdOn).getFullYear();

            if (index === month && this.year === year) {
              if (data.type === 'Input') {
                this.barChartData[0].data[index] += data.value;
              } else if (data.type === 'Output' && data.category.name === 'Déchetterie') {
                this.barChartData[1].data[index] += data.value;
              } else if (data.type === 'Output' && data.category.name === 'Clicotte') {
                this.barChartData[2].data[index] += data.value;
              }
            }
          });
        });

        break;
      default:
        break;
    }
  }

  private initSub(): void {

    this.subscription
      .add(
        this.recordsService.eventsListSubject.asObservable().subscribe(event => {
          this.dataService.dataGraph$.next(event?.body);
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.typeTime$.asObservable().subscribe(typeTime => {
          this.typeTime = typeTime;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.dataGraph$.asObservable().subscribe(dataGraph => {
          this.data = dataGraph;
          this.cdr.detectChanges();
          this.initGraph();
          this.initValueGraph();
        })
      );


  }


}
